import 'babel-polyfill'
require('es6-promise').polyfill();
require('es6-promise/auto');
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../node_modules/bootstrap-select/dist/css/bootstrap-select.min.css'
import '../node_modules/bootstrap/dist/js/bootstrap.min.js'
// import '../node_modules/bootstrap/js/dropdown.js'
import '../node_modules/bootstrap-select/dist/js/bootstrap-select.js'
import 'swiper/dist/css/swiper.min.css';
Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

let bannerClick = (url) => {
  console.log(url);
  if (!url) return
  window.open(url, '_blank');
  // let reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
  // if (!reg.test(url)) {
  //   console.log('不是');
  // } else {
  //   window.open(url, '_blank');
  //   console.log('是');
  // }
}
Vue.prototype.$bannerClick = bannerClick

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  $,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js